"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * An opinionated layout container which provides standard gutters that line up with the `GlobalNav`.
 * The left gutter on larger devices will line up with the first navigation item in the global nav.
 * It is intended to help with generic page layouts which don't use the crate system and also
 * don't use a max width. Consumers may also make use of the underlying
 * `sb-global-gutters` and `sb-global-gutters--logoOffset` classes as needed to
 * achieve standard gutters.
 *
 */
var FullWidthContainer = function FullWidthContainer(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-global-gutters sb-global-gutters--logoOffset ".concat(className)
  }, children);
};
FullWidthContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string
} : {};
FullWidthContainer.displayName = 'FullWidthContainer';
var _default = exports["default"] = FullWidthContainer;